import React, { useEffect, useState } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate } from 'react-router-dom';

interface GameAccessDeniedDialogProps {
  gameId: number;
  redirectUrl?: string;
  autoRedirectSeconds?: number;
}

export const GameAccessDeniedDialog: React.FC<GameAccessDeniedDialogProps> = ({
  gameId,
  redirectUrl = '/mylibrary/games',
  autoRedirectSeconds = 5
}) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(autoRedirectSeconds);

  const handleRedirect = () => {
    navigate(redirectUrl, { replace: true });
  };

  useEffect(() => {
    if (countdown <= 0) {
      handleRedirect();
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  return (
    <Dialog
      title={'Access Denied'}
      onClose={handleRedirect}
      width={500}
      autoFocus={true}>
      <div className={'py-2'}>
        <div className={'d-flex align-items-center mb-3 text-danger'}>
          <span
            className={'material-symbols-outlined me-2'}
            style={{ fontSize: '2.2rem' }}>
            block
          </span>
          <h5 className={'mb-0 font-weight-bold'}>Access Denied</h5>
        </div>
        <p className={'text-secondary mb-2'} style={{ fontSize: '14px', lineHeight: '1.5' }}>
          You do not have permission to access this game. It belongs to a different organisation. 
          If you believe you should have access, please contact your organisation administrator.
        </p>
        <p className={'text-muted small mb-0'}>
          Redirecting to My Library in <strong>{countdown}</strong> second{countdown !== 1 ? 's' : ''}...
        </p>
      </div>
      <DialogActionsBar>
        <Button themeColor={'primary'} onClick={handleRedirect}>
          Back to My Library
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default GameAccessDeniedDialog;
